import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#2C4570',
        secondary: '#BF3F45',
        grey: '#707070',
        'grey-light': '#EBEEF2',
        'blue-light': '#2979FF',
        'blue-dark': '#181469',
        black: '#000',
        white: '#fff',
      },
    },
  },
  options: {
    customProperties: true,
  },
  icons: {
    iconfont: 'mdi',
  },
});
